import styles from './PrintContainer.module.css';

const dev = process.env.NODE_ENV === 'development';

const getPrintContainer = (): HTMLIFrameElement =>
  document.getElementById('printContainer') as HTMLIFrameElement;

const style = `
<style>
  table {
    width: 100vw;
    margin-top: 10px;
  }
  td, th {
    padding: 10px;
    text-align: left;
  }
  .MuiAlert-icon {
    display: none;
  }
  .grunduppgifterPrint td:nth-child(1) {
    width: 32%;
  }
  .hideInPrint {
    display: none;
  }
</style>
`;

const header = dev
  ? `<img src="https://legoasutv01.prodstod.se/fsok/img/fastighetsok_header.svg" />`
  : `<img src="/fsok/img/fastighetsok_header.svg" />`;

export const printHtml = (printContents: string): boolean => {
  const printContainer = getPrintContainer();
  if (!printContainer) {
    return false;
  }

  const printWindow = printContainer.contentWindow;
  printWindow.document.open();
  printWindow.document.write(printContents);
  printWindow.document.body.innerHTML = `${header}${printWindow.document.body.innerHTML}${style}`;
  printWindow.document.close();
  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
  return true;
};

export const PrintContainer = () => (
  <iframe id="printContainer" className={styles.printContainer}></iframe>
);

